import { Link } from 'react-router-dom';
import { useServiceMap } from '@/hooks';

interface ServiceCellProps {
  serviceId: string;
}

/**
 * Tabellenzelle die Service-Anzeigename + ID anzeigt (analog MerchantCell).
 * Spec 409: Anzeigename = `displayName` → `description` → serviceId (aufgeloest in
 * useServiceMap), hier getrimmt — manche Werte tragen Trailing-Newlines. Der Name ist
 * klickbar und navigiert zur Service-Detail-Seite.
 * Fallback: zeigt nur die serviceId wenn kein brauchbarer Anzeigename vorliegt.
 */
export function ServiceCell({ serviceId }: ServiceCellProps) {
  const { resolveServiceName } = useServiceMap();
  const name = resolveServiceName(serviceId).trim();
  const hasName = name !== '' && name !== serviceId;

  return (
    <div>
      {hasName && (
        <Link
          to={`/services/${serviceId}`}
          className="font-medium text-primary hover:underline"
          onClick={(e) => e.stopPropagation()}
        >
          {name}
        </Link>
      )}
      <div className="text-xs text-muted-foreground font-mono">{serviceId}</div>
    </div>
  );
}
